import { tagColorBorder, tagColorToHex } from './tagging.utils'
import { TagPill } from './TagPill'
import { useTagging } from './useTagging'

export const TagMirror = () => {
  const { inputText, selectedColor } = useTagging()

  if (!inputText.trim()) {
    return null
  }

  return (
    <TagPill
      className="TagMirror"
      style={{
        backgroundColor: tagColorToHex(selectedColor),
        borderColor: tagColorBorder(selectedColor),
      }}
    >
      <span className="TagMirror-text">{inputText}</span>
    </TagPill>
  )
}
